var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"Статистика за продукти"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"footer",fn:function(){return undefined},proxy:true}])},[(!_vm.loading)?_c('OrdersStatisticsTable',{attrs:{"stats":_vm.stats}}):_c('Loading',{attrs:{"variant":"is-white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }